import React from 'react';
import Breadcrumb from './Breadcrumb.js'
import Footer from './Footer.js'

function CentralLayout(props) {
//            <Breadcrumb stack={props.stack} />
//            <Footer />

    return (
        <React.Fragment>
            <section className="content central">
                {props.header}
                {props.content}
            </section>
        </React.Fragment>
    );
}

export default CentralLayout;